import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'dict', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/dict.js').default) });
app.model({ namespace: 'global', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/global.js').default) });
app.model({ namespace: 'menu', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/menu.js').default) });
app.model({ namespace: 'personalPotential', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/personalPotential.js').default) });
app.model({ namespace: 'setting', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/setting.js').default) });
app.model({ namespace: 'user', ...(require('/var/lib/jenkins/workspace/ancare-business-prev/src/models/user.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
